/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

angular.module('aviApp').directive('alertsPage', function() {
    return {
        restrict: 'AE',
        transclude: true,
        scope: true,
        controller: 'AlertsController',
        templateUrl: 'src/views/application/alerts.html',
    };
});
